import { ChangeDetectorRef, Component } from '@angular/core';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { LoadingConst } from 'src/app/core/constants/color-loading';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';
import { LoadingAbsoluteService } from 'src/app/core/services/loading-absolute.service';

const PrimaryColor = LoadingConst.colorPrimary;
const SecondaryColor = LoadingConst.colorSecondary;

@Component({
  standalone: false,
  selector: 'app-loading-absolute',
  templateUrl: './loading-absolute.component.html',
  styleUrls: ['./loading-absolute.component.css']
})
export class LoadingAbsoluteComponent {
  isVisible = false;
  parametros: any = {};
  informacion: any;
  fillColor: string = '#0f395c';

  public primaryColour = PrimaryColor;
  public secondaryColour = SecondaryColor;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  constructor(
    private loadinService: LoadingAbsoluteService,
    private secureStorageService: SecureStorageService,
    private cdRef: ChangeDetectorRef
    
  ) { }

  ngOnInit(): void {

    this.loadinService.isVisible$.subscribe(isVisible => {
      this.isVisible = isVisible;
      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 0);
    });
  
    this.fillColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primario').trim();
  
    const designConfig = this.secureStorageService.getData('designConfig');
    if (designConfig) {
      try {
        const data = JSON.parse(designConfig);
        this.parametros = data;
        if (data.LOADING_MENSAJE_EQUIFAX) {
          const info = data.LOADING_MENSAJE_EQUIFAX;
          this.informacion = JSON.parse(info);
        }
        this.primaryColour = data.COLOR_TEMA_PRIMARIO ? data.COLOR_TEMA_PRIMARIO : PrimaryColor;
        this.secondaryColour = data.COLOR_TEMA_SECUNDARIO ? data.COLOR_TEMA_SECUNDARIO : SecondaryColor;
      } catch (error) {
        console.error('Error parsing designConfig:', error);
      }
    }
  }
}
